/* import __COLOCATED_TEMPLATE__ from './sq-card.hbs'; */
/**
## Card

Cards are embeddable containers used to group related content.

#### Contextual components
 `sq-card` yields contextual components.

 | Contextual Name | Component                                               |
 |-----------------|---------------------------------------------------------|
 | card.header     | [sq-card/header](/components/glass/sq-card/header.html) |
 | card.body       | [sq-card/body](/components/glass/sq-card/body.html)     |
 | card.footer     | [sq-card/footer](/components/glass/sq-card/footer.html) |

 The footer again yields contextual components.

 | Contextual Name          | Component                                                     |
 |--------------------------|---------------------------------------------------------------|
 | footer.button            | [sq-button](/components/glass/sq-button.html) |
 | footer.button-primary    | [sq-button](/components/glass/sq-button.html) |
 | footer.button-secondary  | [sq-button](/components/glass/sq-button.html) |

```example
@title Basic example

@hbs
{{#sq-card as |card|}}
  {{card.header title="Card Title"
                link=(hash href="/" text="Link Text")}}
  {{#card.body}}
    Card Body
  {{/card.body}}
  {{#card.footer as |footer|}}
    {{footer.button-primary label="Button"}}
  {{/card.footer}}
{{/sq-card}}
```

```example
@title Blade example
@description Pass `context="BLADE"` when using cards inside a blade.

@hbs
 {{#sq-card context="BLADE" as |card|}}
   {{card.header title="Card In Blade"}}
   {{#card.body}}
     Card Body
   {{/card.body}}
   {{#card.footer as |footer|}}
     {{footer.button-primary label="Button"}}
   {{/card.footer}}
 {{/sq-card}}
```

@param {string} [context] Determines the parent context in which this card is shown, which applies appropriate class name bindings.
@param {boolean} [isDisabled=false] Whether to show the disabled styling for the card

Style dependencies at: `@square/glass-ui/addon/styles/@square/data-view/card/`
*/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { CONTEXT } from '@square/glass-ui/utils/dialog-actions';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['card'],
  classNameBindings: ['contextClass', 'isDisabled:card--is-disabled'],
  // Passed in:
  context: null,
  isDisabled: false,
  contextClass: computed('context', function () {
    switch (this.get('context')) {
      case CONTEXT.BLADE:
        return 'card--in-blade';
      default:
        return '';
    }
  })
});